import { useNavigate } from "react-router-dom";
import { Building2, QrCode, Wallet, Package, Link2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const IMG = "https://images.unsplash.com/photo-1754597302822-4b96f3442d3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export default function PerBnb() {
  const navigate = useNavigate();
  const features = [
    { icon: Package, title: "Pacchetti su misura", desc: "Configura i pacchetti disponibili e decidi il prezzo finale applicato ai tuoi ospiti." },
    { icon: Wallet, title: "Margine trasparente", desc: "Imposta il tuo margine: il sistema separa automaticamente quota locale, margine e commissione." },
    { icon: Link2, title: "Locali convenzionati", desc: "Scegli i bar e le pasticcerie della tua città e richiedi il collegamento." },
    { icon: QrCode, title: "QR code per camera", desc: "Genera QR code per struttura o camera, scaricabili in PNG e PDF stampabile." },
  ];
  return (
    <div>
      <section className="bg-cream">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-orange bg-orange/10 px-4 py-1.5 rounded-full">
              <Building2 className="w-3.5 h-3.5" /> Per i B&B
            </span>
            <h1 className="mt-6 text-4xl lg:text-5xl font-extrabold text-navy tracking-tight">Offri colazioni di qualità senza gestirle</h1>
            <p className="mt-4 text-lg text-navy/70 leading-relaxed">
              Aggiungi un servizio che i tuoi ospiti ameranno. MorningBox gestisce ordini, locali e pagamenti, tu pensi solo all'accoglienza.
            </p>
            <Button onClick={() => navigate("/registra/bnb")} className="mt-8 rounded-full bg-navy text-white h-12 px-6" data-testid="perbnb-register-btn">
              Registra la tua struttura
            </Button>
          </div>
          <img src={IMG} alt="B&B" className="rounded-3xl brand-shadow w-full h-[420px] object-cover" />
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid sm:grid-cols-2 gap-5">
        {features.map((f, i) => (
          <div key={i} className="bg-white border border-navy/10 rounded-2xl p-7 hover:shadow-md transition-shadow">
            <div className="w-12 h-12 rounded-xl bg-cream flex items-center justify-center"><f.icon className="w-6 h-6 text-orange" /></div>
            <p className="mt-4 font-semibold text-navy text-lg">{f.title}</p>
            <p className="mt-2 text-sm text-navy/60 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </section>
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-16">
        <div className="bg-navy rounded-3xl p-10 text-white">
          <h2 className="text-2xl font-bold">Cosa puoi fare dal tuo pannello</h2>
          <div className="mt-6 grid sm:grid-cols-2 gap-3">
            {["Creare ordini per gli ospiti", "Vedere lo stato di ogni ordine", "Gestire i pacchetti disponibili", "Generare e stampare QR code", "Invitare bar e pasticcerie", "Consultare storico, incassi e margini"].map((t) => (
              <div key={t} className="flex items-center gap-2 text-white/80"><CheckCircle2 className="w-5 h-5 text-orange shrink-0" />{t}</div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
